import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useStyles } from './styles';

function SymptomChipTitle({ srcImg, title }) {
  const classes = useStyles();

  return (
    <Box className={classes.chip}>
      <Box className={classes.imgContainer}>
        <img src={srcImg} alt="" className={classes.img} />
      </Box>
      <Typography className={classes.chipTitle}>{title}</Typography>
    </Box>
  );
}

export default SymptomChipTitle;
